import PropTypes from 'prop-types';
import React from 'react';
import MapLink from 'components/MapLink';

const DetailsAddress = (props) => {
  const address = props.address || '';
  const city = props.city || '';
  const state = props.state || '';
  const zipCode = props.zipCode || '';

  return (
    <MapLink {...props}>
      <span>{address}</span><br />
      <span>{city}, {state}, {zipCode}</span>
    </MapLink>
  );
};

DetailsAddress.propTypes = {
  address: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zipCode: PropTypes.string,
};

export default DetailsAddress;



// WEBPACK FOOTER //
// ./client/app/shared/components/DetailsAddress/index.jsx